"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRestrictionState = exports.ONLINE_PAYMENT_RESTRICTION_REASONS = exports.ONLINE_PAYMENT_RESTRICTION_ACTIONS = void 0;
exports.ONLINE_PAYMENT_RESTRICTION_ACTIONS = {
    DISABLED: 'disabled',
    ENABLED: 'enabled'
};
exports.ONLINE_PAYMENT_RESTRICTION_REASONS = {
    NSF_THRESHOLD_EXCEEDED: 'nsf_threshold_exceeded',
    NSF_THRESHOLD_EXCEEDED_OBSERVED: 'nsf_threshold_exceeded_observed',
    COOLING_OFF_PERIOD_PASSED: 'cooling_off_period_passed',
    ALREADY_ENABLED_ACKNOWLEDGED: 'already_enabled_acknowledged',
    EVICTION_CANCELED: 'eviction_canceled',
    MANUAL_COURTESY_WAIVER: 'manual_courtesy_waiver'
};
const getRestrictionState = (lastRestriction, occupancyDate) => {
    var _a;
    const failedPaymentCountStartDate = (_a = lastRestriction === null || lastRestriction === void 0 ? void 0 : lastRestriction.failed_payment_count_start_date) !== null && _a !== void 0 ? _a : occupancyDate;
    return {
        isRestricted: (lastRestriction === null || lastRestriction === void 0 ? void 0 : lastRestriction.action) === exports.ONLINE_PAYMENT_RESTRICTION_ACTIONS.DISABLED,
        failedPaymentCountStartDate
    };
};
exports.getRestrictionState = getRestrictionState;
